import React from 'react';
import TwitterText from 'twitter-text';
import cx from 'classnames';
import { StyledCounter } from './Styled';

interface CounterProps {
  maxCharacters: number;
  text: string;
  isTwitter: boolean;
  isOverLimit?: boolean; // Nueva prop para sincronizar con EditorInput
}

const Counter: React.FC<CounterProps> = ({
  maxCharacters,
  text,
  isTwitter,
  isOverLimit
}) => {
  const calculateCount = () => {
    if (isTwitter) {
      return TwitterText.getTweetLength(text);
    }

    const urlPattern = /(?:https?|ftp):\/\/\S+|www\.\S+/g;
    const urls = text.match(urlPattern) || [];
    const urlWeight = 33;

    return (
      text.replace(urlPattern, ' ').trim().length + urls.length * urlWeight
    );
  };

  const currentCount = calculateCount();
  const remainingCharacters = maxCharacters - currentCount;
  const showWarning = remainingCharacters > 0 && remainingCharacters <= 10;
  const finalIsOverLimit = remainingCharacters <= 0;

  return (
    <StyledCounter
      className={cx({
        'max-chars-warning': showWarning,
        'max-chars-error': finalIsOverLimit,
        'max-chars-ok': !showWarning && !finalIsOverLimit
      })}
      title={
        finalIsOverLimit ? 'Has excedido el límite de caracteres' : undefined
      }
    >
      {currentCount}/{maxCharacters}
      {showWarning && !finalIsOverLimit && ' (cerca del límite)'}
      {finalIsOverLimit && ' (límite excedido)'}
    </StyledCounter>
  );
};

Counter.displayName = 'Counter';

export default React.memo(Counter);
